export const firebaseConfig = {
  apiKey: "AIzaSyCKmLcmRYCPNXUAtVycYndMjY15nqK3P5U",
  authDomain: "jidoka.ca",
  databaseURL: "https://jidoka-voltera.firebaseio.com",
  projectId: "jidoka-voltera",
  storageBucket: "jidoka-voltera.appspot.com",
  messagingSenderId: "341413025518",
  appId: "1:341413025518:web:f713b7fd0313819a",
  measurementId: "G-VL7KGBGE8M",
  // Web OAuth client used by Google Identity Services for PWA-safe sign-in.
  googleClientId: "341413025518-gkphtm19egtuvi5bs08t7j88p7qobuet.apps.googleusercontent.com"
};
